import { Button, buttonVariants } from "@/components/ui/button/button";
import BrandedSuccessLottie from "@/components/ui/BrandedSuccessLottie";
import Typography from "@/components/ui/typography";
import { useLoaderData, useNavigate } from "@tanstack/react-router";

export default function EmailVerified() {
	const { name } = useLoaderData({ from: "__root__" });
	const navigate = useNavigate();

	return (
		<div className="flex flex-col items-center justify-center transition-opacity duration-300 gap-3">
			<div className="flex flex-col items-center mb-4 space-y-3">
				<div className="max-w-56 w-full">
					<BrandedSuccessLottie />
				</div>
				<div>
					<div className="flex flex-col items-center w-full max-w-md">
						<Typography variant="h2" color="primary">
							Email Verified
						</Typography>
						<Typography
							variant="p"
							color="primary"
							className="text-center mt-2 mb-8"
						>
							Your email address has been successfully verified. Please verify
							your phone number next to continue with your {name} account.
						</Typography>
					</div>
				</div>
				<Button
					onClick={() =>
						navigate({
							to: "/sign_up/verify-account",
							search: {
								intent: "sign_up",
							},
						})
					}
					className={buttonVariants({
						variant: "default",
						className: "w-full ",
					})}
				>
					Continue
				</Button>
			</div>
		</div>
	);
}
